export default __webpack_public_path__ + "static/media/voucherUsage.2054d093.svg";